module.exports = __webpack_public_path__ + "img/47-CASACCA-BAROLO-U-COLORI-UNITI-STAMPE-LINO-PANTALONE-MARTE-SMLXL-COLORI-UNITI1.3f561587.jpg";